import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react'
import { CustomTextField , maxLengthValidation, minLengthValidation, passwordRegexPattern } from '../../../helper';
import styles from '../../../features/ChangePassword/ResetPassword.module.css'

interface PasswordProps{
    errors: any,
    register: any,
  skipComplexityValidation?: boolean,
  className?: string
}
const PasswordTextField = CustomTextField();
  
const PasswordInputField = ({errors,register,skipComplexityValidation = false, className}:PasswordProps) => {
  const [showPassword,setShowPassword] = useState<boolean>(false);
  const handleClickShowPassword =(e:React.MouseEvent<HTMLButtonElement>)=>{
    e.preventDefault();
    setShowPassword((show)=> !show);
  }
  const passwordValidationRules: any = {
    required: "Password is required!",
    minLength: minLengthValidation,
    maxLength: maxLengthValidation,
  };

  if (!skipComplexityValidation) {
    passwordValidationRules.pattern = {
      value: passwordRegexPattern,
      message: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    };
  }

  return (
    <>
     <PasswordTextField 
          variant={"outlined"}
          className={className}
          name={"password"}
          type={showPassword ? "text" : "password"}
          {...register("password", passwordValidationRules)}
          fullWidth
          placeholder={"Enter Password"}
          InputProps={{
              style: {
                borderRadius: 0,
                fontFamily: 'var(--body-b3-12-semibold-left)',
                fontSize: 'var(--body-b2-14-semibold-left-size)',
                boxSizing: 'border-box',
                width: '100%',
              },
              endAdornment: <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  edge="end"
                                  disableRipple
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
            }}
            error={Boolean(errors?.password?.message)}
          />
         <span className={styles.errorMsgStyle}>{errors?.password?.message}</span>
    </>
  )
}

export default PasswordInputField
